export default __webpack_public_path__ + "static/media/respect.9c53ca1f.png";